const formatNewLines = (str?: string) => (str ? str.replace(/\r/g, '\n') : '');

export default formatNewLines;
